import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';

const defaultState = {
	preview: null,
	list: null,
	parameters: null,
	pending: false,
	error: null,
	at: null,
	// export
	exporting: false,
	progress: null, // { percent, done, total }
	csv: null,
};

function apiReducer(state = defaultState, action) {
	let _state;
	switch (action.type) {
		case actions.deviceUsages.request.type:
			if (action.clear) {
				_state = { ...defaultState };
			} else {
				_state = {...state};
			}
			return {
				..._state,
				parameters: action.parameters,
				pending: true,
				error: null,
				at: action.clear ? new Date() : _state.at
			};
		case actions.deviceUsages.success.type:
			const usages = action.usages;
			const list = state.list ? (usages ? state.list.concat(usages) : state.list) : (usages ? [...usages] : []);
			_state = {...state};
			return {
				..._state,
				list,
				parameters: state.parameters,
				pending: false,
				error: null
			};
		case actions.deviceUsages.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.deviceUsages.cancel.type:
			return {
				...state,
				pending: false
			};
		default:
			return state;
	}
}


function exportReducer(state, action) {
	switch (action.type) {
		case actions.deviceUsages.export.type:
			return {
				...state,
				exporting: true,
				progress: null,
				csv: null
			}
		case actions.deviceUsages.exportProgress.type:
			return {
				...state,
				progress: {
					percent: action.progress,
					done: action.count,
					total: action.total
				}
			}
		case actions.deviceUsages.exportDone.type:
			return {
				...state,
				parameters: state.parameters,
				exporting: false,
				csv: action.csv
			}
		case actions.deviceUsages.exportClear.type:
			return {
				...state,
				csv: null
			}
		default:
			return state;
	}
}

const reducer = reduxSwitch([apiReducer, exportReducer], defaultState);

export { reducer };
